import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { Box, ModalClose } from '@mui/joy';
import { Popover, List, ListItem, ListItemText, Typography } from '@mui/material';

const dataProviderName = 'campaigns/campaignautoassignment';
const wizardAction = 'operatorAutoAssignment'

const OperatorAssignation = ({ campaignId, setSelected }) => {
    const { t } = useTranslation();
    const { doAction, item } = useDataProvider(dataProviderName);
    const [loading, setLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [result, setResult] = useState(null);

    const handleOperatorAssignation = (e) => {
        setLoading(true);
        setAnchorEl(e.currentTarget);
        setResult(null);

        doAction({
            action: wizardAction,
            model: dataProviderName,
            data: { campaignId: campaignId }
        }).then(() => {
            setLoading(false);
            setSelected([]);
            setResult(item?.data?.result);
        });
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                onClick={handleOperatorAssignation}
                label={t("Auto Assegna")}
                icon="faPeopleArrows"
                family="fas"
                variant="solid"
                size="small"
                className="button-select"
                loading={loading}
            />
            <OperatorAssignationResult
                result={result}
                anchorEl={anchorEl}
                onClose={handleClose}
            />
        </>
    );
};

const OperatorAssignationResult = ({ result, anchorEl, onClose }) => {
    const { t } = useTranslation();
    const open = Boolean(anchorEl && result);

    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'center',
                horizontal: 'center',
            }}
            sx={{
                '& .MuiPopover-paper': {
                    top: '50% !important',
                    left: '50% !important',
                    transform: 'translate(-50%, -50%) !important',
                    width: 600,
                    maxWidth: 600,
                    maxHeight: '80vh',
                }
            }}
            disableRestoreFocus
            disableAutoFocus
            disableEnforceFocus
            className="mtska-child-row-info-detail"
        >
            <Box sx={{ p: 2, minWidth: 200 }}>
                <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
                    <Typography variant="h6">Risultati Assegnazione</Typography>
                </Box>
                <List sx={{ p: 0 , paddingTop:2}}>
                    {result?.map((operator, index) => (
                        <ListItem key={index} sx={{ p: 0, paddingLeft:2 }}>
                            <ListItemText
                                primary={operator.name}
                                secondary={
                                    <>
                                        <div>Assegnazioni: {operator.numberOfAssignations}</div>
                                        <div>Città: {operator.workedCities.join(', ')}</div>
                                    </>
                                }
                            />
                        </ListItem>
                    ))}
                </List>
            </Box>
        </Popover>
    );
};


export default OperatorAssignation;
